export default "__VITE_ASSET__DCubW9Pg__"